import React from "react";
import "./top-automated-tasks-view.scss";

export interface ITopAutomatedTask {
    name: string;
    displayName: string;
    count: number;
    timeSaved: number;
    costSaved: number;
}

export interface ITopAutomatedTasksViewProps {
    tasks: ITopAutomatedTask[];
}

const TopAutomatedTasksView: React.FC<ITopAutomatedTasksViewProps> = ({tasks}) => {
    // Tasks are already sorted and limited in the processor, no need to sort again
    const topTasks = tasks;

    const formatHours = (hours: number): string => {
        return `${Math.round(hours)} hrs`;
    };

    const getActivityDisplayName = (activityName: string): string => {
        const displayNames: {[key: string]: string} = {
            featureProvisioning: "Feature Provisioning",
            capture: "Configuration Capture",
            backup: "Configuration Backup",
            audit: "Configuration Audit",
            osUpgrade: "OS Upgrade",
            deviceDiscovery: "Device Discovery",
            configurationDeployment: "Configuration Deployment",
        };

        return (
            displayNames[activityName] ||
            activityName
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase())
                .trim()
        );
    };

    return (
        <div className="top-automated-tasks-view">
            <div className="top-automated-tasks-view__tasks">
                {topTasks.length > 0 ? (
                    topTasks.map((task, index) => (
                        <div key={task.name} className="top-automated-tasks-view__task-item">
                            <div className="top-automated-tasks-view__task-name">
                                {getActivityDisplayName(task.name)}
                            </div>
                            <div className="top-automated-tasks-view__task-hours">
                                {formatHours(task.timeSaved)}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="top-automated-tasks-view__empty">
                        <p>No automated tasks found for the selected period.</p>
                        <p>Try adjusting your date range or check your task configuration.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TopAutomatedTasksView;
